import * as actionType from "../types/ActionTypes";
import axios from "../../shared/axios";
import Swal from "sweetalert2";
import { baseUrl } from "../../shared/baseURL";
import { redirect } from "react-router-dom";

export const teachersSetData = (teachers) => {
  return {
    type: actionType.TEACHERS_SET_DATA,
    teachers: teachers,
  };
};

export const teachersFailData = (error) => {
  return {
    type: actionType.TEACHERS_FAIL_DATA,
    error: error,
  };
};

export const teachersLoading = () => {
  return {
    type: actionType.TEACHERS_LOADING,
  };
};

export const teachersGetData = () => {
  return (dispatch) => {
    dispatch(teachersLoading());
    axios
      .get(baseUrl + "/teachers", {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        //console.log(res.data, "res");
        dispatch(teachersSetData(res.data));
      })

      .catch((error) => dispatch(teachersFailData(error)));
  };
};

export const deleteTeachersFail = (error) => {
  return {
    type: actionType.DELETE_TEACHERS_FAIL,
    error: error,
  };
};

export const deleteTeachers = (id, data) => {
  return (dispatch) => {
    if (id) {
      axios
        .delete(baseUrl + `/teachers/${data.id}`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data?.token,
          },
        })
        .then(() => {
          Swal.fire("Deleted!", "Your file has been deleted.", "success").then(
            () => {
              dispatch(teachersGetData(data));
            }
          );
        })
        .catch((error) => dispatch(deleteTeachersFail()));
    }
  };
};

export const postTeachersDataStart = () => {
  return {
    type: actionType.POST_TEACHERS_DATA_START,
  };
};

export const postTeachersDataFail = (error) => {
  return {
    type: actionType.POST_TEACHERS_DATA_FAIL,
    error: error,
  };
};

export const postTeachersDataSuccess = (success) => {
  return {
    type: actionType.POST_TEACHERS_DATA_SUCCESS,
    success: success,
  };
};

export const teachersPostLoading = () => {
  return {
    type: actionType.TEACHERS_POST_LOADING,
  };
};

export const postTeachersData = (teachers, setSubmitting, navigate, url) => {
  return (dispatch) => {
    dispatch(postTeachersDataStart());
    dispatch(teachersPostLoading());
    axios
      .post(baseUrl + "/teachers", teachers, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(postTeachersDataSuccess(res.data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Redirecting To Payment Page",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (setSubmitting) {
            setSubmitting(false);
          }
          window.open(url, "_blank");
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(postTeachersDataFail(error));
      });
  };
};
export const postTeacher = (teachers, setSubmitting, resetForm) => {
  return (dispatch) => {
    dispatch(postTeachersDataStart());
    dispatch(teachersPostLoading());
    axios
      .post(baseUrl + "/teachers", teachers, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(postTeachersDataSuccess(res.data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Successfully Registered",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (setSubmitting) {
            setSubmitting(false);
          }
          resetForm();
          // window.open(url, "_blank")
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(postTeachersDataFail(error));
      });
  };
};

export const updateTeachersDataStart = () => {
  return {
    type: actionType.UPDATE_TEACHERS_DATA_START,
  };
};

export const teachersUpdateLoading = () => {
  return {
    type: actionType.TEACHERS_UPDATE_LOADING,
  };
};

export const updateTeachersDataFail = (error) => {
  return {
    type: actionType.UPDATE_TEACHERS_DATA_FAIL,
    error: error,
  };
};

export const updateTeachersDataSuccess = (success) => {
  return {
    type: actionType.UPDATE_TEACHERS_DATA_SUCCESS,
    success: success,
  };
};

export const updateTeachersData = (data, teachers, toggle, setSubmitting) => {
  return (dispatch) => {
    dispatch(updateTeachersDataStart());
    dispatch(teachersUpdateLoading());

    axios
      .put(baseUrl + `/teachers/${data.id}`, teachers, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(updateTeachersDataSuccess(res.data));
        dispatch(teachersGetData(data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Successfully Updated !",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (toggle) {
            toggle();
          }
          if (setSubmitting) {
            setSubmitting(false);
          }
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(updateTeachersDataFail(error));
      });
  };
};
